import type { User } from '@supabase/supabase-js';

/**
 * Ist das dieselbe angemeldete Person wie vorher?
 *
 * Supabase erneuert das Zugangstoken von sich aus -- unter anderem, wenn der
 * Browser-Tab wieder sichtbar wird. Dabei feuert onAuthStateChange und liefert
 * ein *neues* User-Objekt, obwohl es dieselbe Person ist.
 *
 * Wird dieses Objekt ungeprueft in den State geschrieben, sieht React eine
 * neue Identitaet. In useTenants haengen `fetchTenants` (useCallback) und der
 * Lade-Effekt an genau diesem Wert: Der Effekt laeuft erneut, setzt
 * `isLoading` auf true -- und die ganze App faellt zurueck auf den
 * Ladebildschirm, obwohl sich nichts geaendert hat. Danach laedt alles
 * Nachgelagerte ebenfalls neu.
 *
 * Deshalb wird die bisherige Referenz behalten, solange es dieselbe Person
 * ist. Die Sitzung selbst (mit dem frischen Token) wird davon unabhaengig
 * immer aktualisiert.
 */
export function isSameUser(previous: User | null, next: User | null): boolean {
  if (previous === next) return true;
  if (!previous || !next) return false;
  return previous.id === next.id;
}
